<template lang="pug">
#ranking-categoria-inteligencia-territorial
    .bloco-tabs
        el-tabs.bloco-tabs-dimensao(
            tab-position='left',
            v-model='tabAtiva',
            @tab-click='tabClick'
        )
            el-tab-pane(name='1')
                span.bloco-tabs-dimensao-menu(slot='label')
                    el-tooltip(
                        effect='dark',
                        placement='right',
                        :content="$t('mensagens.inteligenciaTerritorial.areaAgricultavel')"
                    )
                        img(
                            v-if='tabAtiva === "1"',
                            src='@/assets/lyra-icons/icons-tab-menu/agricultura-selecionado.svg'
                        )
                        img(
                            v-else,
                            src='@/assets/lyra-icons/icons-tab-menu/agricultura.svg'
                        )

                .bloco-tabs-conteudo
                    h2(:style='styleTituloGrafico') {{ tituloGrafico }}
                    GraficoBarrasInteligenciaTerritorial(
                        :dados='verificarDadosRanking(dadosRanking)',
                        :categorias='somatorioDadosGraficos > 0 ? categoriasRanking : []',
                        :culturaSelecionada='culturaSelecionada',
                        :tabAtiva='tabAtiva',
                        :coresBarras='["#00413C"]',
                        :corUnica='true',
                        :textoLegenda='unidadeLegendaAgricultavel',
                        :isLoadingRanking='isLoadingRanking',
                        textoTooltip=' ha',
                        :key='idGrafico'
                    )

            el-tab-pane(name='2')
                span.bloco-tabs-dimensao-menu(slot='label')
                    el-tooltip(
                        effect='dark',
                        placement='right',
                        :content="$t('mensagens.inteligenciaTerritorial.areaDePastagem')"
                    )
                        img(
                            v-if='tabAtiva === "2"',
                            src='@/assets/lyra-icons/icons-tab-menu/pastagens-selecionado.svg'
                        )
                        img(
                            v-else,
                            src='@/assets/lyra-icons/icons-tab-menu/pastagens.svg'
                        )

                .bloco-tabs-conteudo
                    h2(:style='styleTituloGrafico') {{ tituloGrafico }}
                    GraficoBarrasInteligenciaTerritorial(
                        :dados='verificarDadosRanking(dadosRanking)',
                        :categorias='somatorioDadosGraficos > 0 ? categoriasRanking : []',
                        :culturaSelecionada='culturaSelecionada',
                        :tabAtiva='tabAtiva',
                        :coresBarras='["#740F0F", "#AD6A01", "#4F7200"]',
                        :corUnica='false',
                        :textoLegenda='unidadeLegendaPastagem',
                        :isLoadingRanking='isLoadingRanking',
                        textoTooltip=' ha',
                        :key='idGrafico'
                    )

            el-tab-pane(name='3')
                span.bloco-tabs-dimensao-menu(slot='label')
                    el-tooltip(
                        effect='dark',
                        placement='right',
                        :content="$t('mensagens.inteligenciaTerritorial.producao')"
                    )
                        img(
                            v-if='tabAtiva === "3"',
                            src='@/assets/lyra-icons/icons-tab-menu/produtividade-selecionado.svg'
                        )
                        img(
                            v-else,
                            src='@/assets/lyra-icons/icons-tab-menu/produtividade.svg'
                        )

                .bloco-tabs-conteudo
                    h2(:style='styleTituloGrafico') {{ tituloGrafico }}
                    GraficoBarrasInteligenciaTerritorial(
                        :dados='verificarDadosRanking(dadosRanking)',
                        :categorias='somatorioDadosGraficos > 0 ? categoriasRanking : []',
                        :culturaSelecionada='culturaSelecionada',
                        :tabAtiva='tabAtiva',
                        :coresBarras='["#00413C"]',
                        :corUnica='true',
                        :textoLegenda='unidadeLegendaProducao',
                        :isLoadingRanking='isLoadingRanking',
                        textoTooltip=' ton',
                        :key='idGrafico'
                    )
</template>

<script>
import GraficoBarrasInteligenciaTerritorial from '@/components/inteligenciaTerritorial/GraficoBarrasInteligenciaTerritorial.vue';
import EventBus from '@/utils/eventBus';

export default {
    name: 'RankingCategoriaInteligenciaTerritorial',
    components: {
        GraficoBarrasInteligenciaTerritorial
    },
    props: {
        tipoVisao: {
            type: String,
            default: 'UF'
        },
        dadosRanking: {
            type: Array,
            default: () => []
        },
        categoriasRanking: {
            type: Array,
            default: () => []
        },
        culturaSelecionada: {
            type: String,
            default: ''
        },
        isLoadingRanking: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            idGrafico: 1,
            tabAtiva: '1',
            somatorioDadosGraficos: 0
        };
    },
    computed: {
        tituloGrafico() {
            if (this.tipoVisao === 'ESTADO') {
                return this.$t('mensagens.inteligenciaTerritorial.municipios');
            } else if (this.tipoVisao === 'MUNICIPIO') {
                return this.$t('mensagens.inteligenciaTerritorial.car');
            } else if (this.tipoVisao === 'PAIS') {
                return this.$t('mensagens.inteligenciaTerritorial.unidadesFederativas');
            } else return '';
        },
        unidadeLegendaAgricultavel() {
            if (this.tipoVisao === 'PAIS') {
                return this.$t('mensagens.inteligenciaTerritorial.areaMilhoesHa');
            } else if (this.tipoVisao === 'ESTADO') {
                return this.$t('mensagens.inteligenciaTerritorial.areaMilharesHa');
            } else if (this.tipoVisao === 'MUNICIPIO') {
                return this.$t('mensagens.inteligenciaTerritorial.areaHa');
            } else return this.$t('mensagens.inteligenciaTerritorial.areaMilhoesHa');
        },
        unidadeLegendaPastagem() {
            if (this.tipoVisao === 'PAIS') {
                return this.$t('mensagens.inteligenciaTerritorial.areaMilhoesHa');
            } else if (this.tipoVisao === 'ESTADO') {
                return this.$t('mensagens.inteligenciaTerritorial.areaMilharesHa');
            } else if (this.tipoVisao === 'MUNICIPIO') {
                return 'Área (ha)';
            } else return this.$t('mensagens.inteligenciaTerritorial.areaMilharesHa');
        },
        unidadeLegendaProducao() {
            if (this.tipoVisao === 'PAIS') {
                return this.$t('mensagens.inteligenciaTerritorial.producaoMilhoesTon');
            } else if (this.tipoVisao === 'ESTADO') {
                return this.$t('mensagens.inteligenciaTerritorial.producaoMilhoesTon');
            } else if (this.tipoVisao === 'MUNICIPIO') {
                return this.$t('mensagens.inteligenciaTerritorial.producaoTon');
            } else return this.$t('mensagens.inteligenciaTerritorial.producaoMilTon');
        },
        styleTituloGrafico() {
            if (this.tipoVisao === 'PAIS') {
                return 'margin-left: 12px';
            } else if (this.tipoVisao === 'ESTADO') {
                return 'margin-left: 8px';
            } else if (this.tipoVisao === 'MUNICIPIO') {
                return 'margin-left: 12px';
            } else return 'margin-left: 4px';
        }
    },
    methods: {
        tabClick() {
            this.setarTituloContainerGrafico(this.tabAtiva, this.culturaSelecionada);
            this.idGrafico++;
        },
        verificarDadosRanking(dados) {
            let somatorio = 0;
            dados.map(item => {
                item.data.map(valor => {
                    somatorio += valor;
                });
            });
            this.somatorioDadosGraficos = somatorio;
            if (somatorio === 0) {
                return [{ data: [], name: '' }];
            } else if (somatorio > 0) {
                return dados;
            }
        },
        setarTituloContainerGrafico(tabAtiva, culturaSelecionada) {
            let objTag = null;
            let prefixoTituloContainerGrafico = 'Ranking de Área Agricultável';

            if (tabAtiva === '1') {
                prefixoTituloContainerGrafico =
                    'Ranking de Área Agricultável ';
            } else if (tabAtiva === '2') {
                prefixoTituloContainerGrafico =
                    'Ranking de Área de pastagem ';
                if (culturaSelecionada && culturaSelecionada.length > 0) {
                    objTag = {
                        codigo: 'CULTURA',
                        id: culturaSelecionada,
                        nome: culturaSelecionada
                    };
                }
            } else if (tabAtiva === '3') {
                prefixoTituloContainerGrafico =
                    'Ranking de Produção ';
            }
            EventBus.$emit('inteligenciaTerritorial:setar-prefixo-titulo-container-grafico', prefixoTituloContainerGrafico);
            EventBus.$emit('inteligenciaTerritorial:processar-mudanca-tab', tabAtiva, objTag);
        }
    }
};
</script>

<style lang="scss">
#ranking-categoria-inteligencia-territorial {
    display: flex;
    width: inherit;

    .bloco-tabs {
        width: 98%;
        height: 100%;
        display: flex;
        order: 0;
        border-radius: 5px;

        .bloco-tabs-dimensao {
            width: 100%;
            height: 100%;
            border-radius: 5px;

            .bloco-tabs-conteudo {
                width: 100%;
                background: var(--white);
                min-height: 520px;
                box-shadow: 0px 0px 20px rgb(0 0 0 / 10%);
                border-radius: 5px;
                padding: 10px 10px;

                h2 {
                    font-size: 16px;
                    color: #3b3b3b;
                    font-weight: 600;
                    margin-bottom: 2px;
                    margin-top: 10px;
                }
            }
            .bloco-tabs-dimensao-menu {
                display: flex;
                flex-direction: column;
                font-size: 38px;
                padding: 10px 4px;
                height: 64px;

                .lyra-icon::before {
                    content: '';
                    width: 31px;
                    height: 38px;
                }
                .balanca-dimensao.lyra-icon::before {
                    content: '';
                    width: 38px !important;
                    height: 41px !important;
                }
            }
        }
    }
    .bloco-mapa {
        width: 50%;
        height: 525px;
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        margin-bottom: 14px;
    }

    .el-tabs__item {
        text-align: center !important;
        background: var(--white);
        box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
        border-radius: 5px;
        margin-bottom: 9px;
        font-weight: 600;
        height: 64px;

        .lyra-icon::before {
            background-color: var(--primary);
        }
        i.el-tooltip.mdi.mdi-alert-outline {
            color: var(--primary);
        }

        &.is-active {
            .lyra-icon::before {
                background-color: var(--white) !important;
            }
            i.el-tooltip.mdi.mdi-alert-outline {
                color: var(--white) !important;
            }
        }
    }
    .el-tabs__item.is-active {
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .el-tabs__nav-wrap::after {
        content: '';
        background-color: #e1e1e1 !important;
    }
    .el-tabs__active-bar {
        display: none;
    }
}
</style>
